<template>
  <section class="testimonials-section">
    <b-container>
      <h4 class="title">
        Our students and parents <font-awesome-icon icon="heart" /> us!
      </h4>
      <div class="rounded-nav">
        <tiny-slider v-bind="tinySliderOptions">
          <div v-for="i in 9" :key="i">
            <testimonial-card
              :review="reviews[i - 1]"
              v-if="reviews[i - 1]"
            ></testimonial-card>
          </div>
        </tiny-slider>
      </div>
    </b-container>
  </section>
</template>

<script>
import TestimonialCard from "../Templates/TestimonialTemplate.vue";
export default {
  name: "Testimonials",
  components: {
    TestimonialCard
  },
  data() {
    return {
      tinySliderOptions: {
        mouseDrag: true,
        loop: false,
        items: 3,
        gutter: 20,
        swipeAngle: 45,
        controls: false,
        nav: true,
        responsive: {
          640: {
            edgePadding: 20,
            items: 2
          },
          1200: {
            items: 3
          }
        }
      }
    };
  },
  props: {
    reviews: Array
  }
};
</script>

<style></style>
